// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CenteredTemplate_wrapper_AsrMH","content":"CenteredTemplate_content_R3TZF","isDark":"CenteredTemplate_isDark_1-DNA"};